import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormObjectDescriptionListItems from '@/forms/objects/components/FormObjectDescriptionListItems';
import formFieldType, { formFieldText } from '@/forms/helper';
import catalogueFieldComponents from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../../catalogue/hooks/events';
import DatasetEvents from '../../hooks/events';

const CatalogueObjectDescription = ({
  category,
  code,
  field,
  section,
}) => {
  const state = Selectors.useFormFields({ category, code, section });
  const editDataset = DatasetEvents.useEditDataset(category, { code });
  const updateProperties = Events.useUpdateDatasetCatalogueProperties(category, { code });

  const onValueChange = (parent, child, value) => {
    const properties = propertiesWithValue(parent, propertiesWithValue(child, value));
    updateProperties({
      properties, fields: [parent.name, child.name], entity: section, template: state.template,
    });
  };

  return (
    <List className={clsx('aridhia-form-object-description', field.code)}>
      <FormObjectDescriptionListItems
        canEdit={state.canEdit}
        category={category}
        code={code}
        component={(f) => catalogueFieldComponents[formFieldType(f)]}
        field={field}
        onChange={onValueChange}
        showEdit={() => editDataset(state)}
        text={(parent, child) => formFieldText(state.dataset, child, 'catalogue.', parent)}
      />
    </List>
  );
};

export default CatalogueObjectDescription;
